import React from "react";

interface HairlineProps extends React.HTMLAttributes<HTMLHRElement> {
  orientation?: "horizontal" | "vertical";
}

/**
 * 1px universal divider in latte-300. The only divider primitive — no border-2,
 * no shadow-as-divider.
 */
export function Hairline({ orientation = "horizontal", className = "", ...rest }: HairlineProps) {
  const base =
    orientation === "vertical"
      ? "w-px h-full bg-latte-300 dark:bg-latte-800 border-0"
      : "w-full h-px bg-latte-300 dark:bg-latte-800 border-0";

  return <hr className={`${base} ${className}`} {...rest} />;
}

export default Hairline;
